export const LogoMark = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <circle cx="24" cy="24" r="24" fill="#064E3B" />
    <circle cx="24" cy="24" r="19.5" stroke="#C5A059" strokeOpacity="0.75" fill="none" />
    <circle cx="22" cy="24" r="8.5" fill="#C5A059" />
    <circle cx="25" cy="22.5" r="7.4" fill="#064E3B" />
    <path
      d="M30 10.9l1.3 3.1 3.1 1.3-3.1 1.3-1.3 3.1-1.3-3.1-3.1-1.3 3.1-1.3z"
      fill="#C5A059"
    />
  </svg>
);

export const OrnamentDivider = ({ className = "" }) => (
  <div className={`ornament-divider ${className}`} aria-hidden="true">
    <span className="ornament-line ornament-line-left" />
    <svg width="30" height="30" viewBox="0 0 40 40" fill="none">
      <g stroke="#C5A059" strokeWidth="1.5" fill="none">
        <rect x="12.5" y="12.5" width="15" height="15" />
        <rect x="12.5" y="12.5" width="15" height="15" transform="rotate(45 20 20)" />
      </g>
      <circle cx="20" cy="20" r="2.6" fill="#C5A059" />
    </svg>
    <span className="ornament-line ornament-line-right" />
  </div>
);
